module.exports = __webpack_public_path__ + "img/蒙版组32@2x.eba486fc.png";